(function () {
  'use strict';

  angular.module('settings.api', ['ngResource']);
})();
